import { __assign, __rest } from "tslib";
import React from 'react';
import c from 'classnames';
import ModalLayout from '../../../../ModalLayout';
import s from './VerticalLayout.scss';
var VerticalLayout = function (_a) {
    var image = _a.image, title = _a.title, message = _a.message, className = _a.className, footerButtons = _a.footerButtons, rest = __rest(_a, ["image", "title", "message", "className", "footerButtons"]);
    return (React.createElement(ModalLayout, __assign({ className: c(s['root'], className), footer: React.createElement("div", { className: s['footer'] }, footerButtons), content: React.createElement("div", { className: s['content-root'] },
            image && React.createElement("div", { className: s['image'] }, image),
            React.createElement("div", { className: s['title'] }, title),
            React.createElement("div", { className: s['message'] }, message)) }, rest)));
};
VerticalLayout.displayName = 'VerticalLayout';
export default VerticalLayout;
//# sourceMappingURL=VerticalLayout.js.map